import _ from 'lodash';
import BaseStore from 'core/stores/BaseStore';
import { action, observable, makeObservable, override } from 'mobx';
import { CoreUserService, ApplicationService } from 'common/data';
import { organizationTypes, sellerRoles, warehouseRoles, superAdminRoles } from 'common/constants';

class UserStore extends BaseStore {
	@observable roles = [];

	constructor(rootStore) {
		super(rootStore.app.baasic.membershipModule.user);
		this.rootStore = rootStore;
		makeObservable(this);
		this.userService = new CoreUserService(rootStore.app.baasic.apiClient);
		this.applicationService = new ApplicationService(rootStore.app.baasic.apiClient);
	}

	@action
	findUsers = async filter => {
		const response = await this.userService.find(filter);
		_.map(response.data.item, item => {
			var userRoles = [];
			_.each(item.coreUser.usersInRoles, usersInRoles => {
				userRoles.push(usersInRoles.role.roleName);
			});
			item.userRoles = userRoles.join();
		});
		this.response = response.data;
	};

	@action async findByUserName(username, options) {
		const response = await this.userService.findByUserName(username, options);
		return (this.response = response.data);
	}

	@action async createUser(user) {
		const response = await this.service.create(user);
		return (this.response = response.data);
	}

	@action async updateUser(user) {
		await this.service.update(user);
	}

	@action async deleteUser(user) {
		await this.userService.remove(user);
	}

	@action async getUser(id, options = { embed: 'roles' }) {
		const response = await this.service.get(id, options);
		this.item = response.data;
	}

	@action async fetchRoles({ organizationTypeName }) {
		const response = await this.rootStore.app.baasic.membershipModule.lookups.get({ embed: 'role' });
		const rolesList =
			organizationTypeName == organizationTypes.seller
				? Object.values(sellerRoles)
				: organizationTypeName == organizationTypes.warehouse
				? Object.values(warehouseRoles)
				: organizationTypeName == organizationTypes.superAdministrator
				? Object.values(superAdminRoles)
				: null;

		response.data.role = _.filter(response.data.role, role => {
			return _.includes(rolesList, role.name);
		});
		this.response = { item: response.data.role };
	}

	@action async changeUserPassword(userName, password) {
		await this.service.changePassword(userName, password);
	}

	@action.bound async sendPasswordResetMail(passwordResetData) {
		await this.rootStore.app.baasic.membershipModule.passwordRecovery.requestReset({
			recoverUrl: passwordResetData.recoverUrl,
			userName: passwordResetData.userName,
		});
	}

	@action.bound async lockUser(user) {
		await this.service.lock(user);
	}

	@action.bound async unlockUser(user) {
		await this.service.unlock(user);
	}

	@action.bound async approveUser(user) {
		await this.service.approve(user);
	}

	@action.bound async disapproveUser(user) {
		await this.service.disapprove(user);
	}
}

export default UserStore;
